<template>
  <span class="account-plan" :style="{ backgroundColor: 'gray' }">
    {{ displayInfo.title }}
  </span>
</template>

<script>
const DISPLAY_CONFIG = {
  TEACHER: {
    color: 'coral',
    title: 'Giảng viên',
  },
  STUDENT: {
    color: 'indianred',
    title: 'Học viên',
  },
  PERSONAL: {
    color: '#0f6b99',
    title: 'PERSONAL',
  },
  PREMIUM: {
    color: 'coral',
    title: 'PREMIUM',
  },
  ADMIN: {
    color: 'indianred',
    title: 'ADMIN',
  },
}
export default {
  name: 'PricingPlanTag',
  data() {
    return {
      DISPLAY_CONFIG,
    }
  },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayInfo() {
      return (
        DISPLAY_CONFIG[this.name] || {
          color: 'darkgray',
          title: this.name,
        }
      )
    },
  },
}
</script>

<style scoped>
.account-plan {
  background-color: indianred;
  color: white;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
